/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  OtherAccount
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type accountSwitchingGetOtherAccountsResponse200 = {
  data: void
  status: 200
}

export type accountSwitchingGetOtherAccountsResponseSuccess = (accountSwitchingGetOtherAccountsResponse200) & {
  headers: Headers;
};
;

export type accountSwitchingGetOtherAccountsResponse = (accountSwitchingGetOtherAccountsResponseSuccess)

export const getAccountSwitchingGetOtherAccountsUrl = () => {




  return `/api/User/OtherAccounts`
}

export const useAccountSwitchingGetOtherAccountsHook = (): ( options?: RequestInit) => Promise<accountSwitchingGetOtherAccountsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAccountSwitchingGetOtherAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type accountSwitchingDeleteOtherAccountResponse200 = {
  data: void
  status: 200
}

export type accountSwitchingDeleteOtherAccountResponseSuccess = (accountSwitchingDeleteOtherAccountResponse200) & {
  headers: Headers;
};
;

export type accountSwitchingDeleteOtherAccountResponse = (accountSwitchingDeleteOtherAccountResponseSuccess)

export const getAccountSwitchingDeleteOtherAccountUrl = (name: string,) => {




  return `/api/User/OtherAccounts/${name}`
}

export const useAccountSwitchingDeleteOtherAccountHook = (): (name: string, options?: RequestInit) => Promise<accountSwitchingDeleteOtherAccountResponse> => {

      const customFetcher = useSfetchMutator();
      return (name: string, options?: RequestInit) => {

        return customFetcher(getAccountSwitchingDeleteOtherAccountUrl(name),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type accountSwitchingSwitchAccountResponse200 = {
  data: void
  status: 200
}

export type accountSwitchingSwitchAccountResponseSuccess = (accountSwitchingSwitchAccountResponse200) & {
  headers: Headers;
};
;

export type accountSwitchingSwitchAccountResponse = (accountSwitchingSwitchAccountResponseSuccess)

export const getAccountSwitchingSwitchAccountUrl = () => {




  return `/api/User/SwitchAccount`
}

export const useAccountSwitchingSwitchAccountHook = (): (otherAccount?: OtherAccount, options?: RequestInit) => Promise<accountSwitchingSwitchAccountResponse> => {

      const customFetcher = useSfetchMutator();
      return (otherAccount?: OtherAccount, options?: RequestInit) => {

        return customFetcher(getAccountSwitchingSwitchAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(otherAccount)
  }
);
      }
  }


export type accountSwitchingSoftLogoutResponse200 = {
  data: void
  status: 200
}

export type accountSwitchingSoftLogoutResponseSuccess = (accountSwitchingSoftLogoutResponse200) & {
  headers: Headers;
};
;

export type accountSwitchingSoftLogoutResponse = (accountSwitchingSoftLogoutResponseSuccess)

export const getAccountSwitchingSoftLogoutUrl = () => {




  return `/api/User/SoftLogout`
}

export const useAccountSwitchingSoftLogoutHook = (): ( options?: RequestInit) => Promise<accountSwitchingSoftLogoutResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAccountSwitchingSoftLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


